import React, { Component } from 'react';

import {
  FormHelperText, InputAdornment, IconButton, TextField,
} from '@material-ui/core';
import { VisibilityOutlined, VisibilityOffOutlined } from '@material-ui/icons';
import { Trans } from 'react-i18next';

class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  handleClickShowPassword = () => {
    const { showPassword } = this.state;

    this.setState({
      showPassword: !showPassword,
    });
  };

  static handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  render() {
    const {
      input,
      disabled,
      name,
      autoComplete,
      label,
      meta: {
        touched,
        error,
      },
      classes,
    } = this.props;

    const { showPassword } = this.state;

    return (
      <>
        <TextField
          {...input}
          className={`${classes.formInput} ${classes.loginCredentials}`}
          type={showPassword ? 'text' : 'password'}
          disabled={disabled}
          name={name}
          label={label}
          variant="filled"
          autoComplete={autoComplete || 'off'}
          InputProps={{
            endAdornment:
  <InputAdornment position="end">
    <IconButton
      className={classes.fieldIcon}
      aria-label="toggle password visibility"
      onClick={this.handleClickShowPassword}
      onMouseDown={PasswordField.handleMouseDownPassword}
    >
      {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
    </IconButton>
  </InputAdornment>,
          }}
        />
        <FormHelperText className={classes.error}>
          {touched && error
          && <Trans>{touched && error}</Trans>}
        </FormHelperText>
      </>
    );
  }
}

export default PasswordField;
